<script setup>

const newsStore = useNewsStore()

const { params } = useRoute()
const { id } = params

await newsStore.getItem(id)

useSeoMeta({
    title: `Новости - ${newsStore.item.title}` ,
})

</script>
<template>
    <section class="bg-brand-bright md:py-10 pt-0">

        <div class="container px-4 mx-auto">
            <div class="">
                <NuxtLink to="/news" class="text-brand-primary text-base flex gap-1 items-center">  
                    <svg width="15px" height="15px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="" stroke-width="0"></g><g id="" stroke-linecap="round" stroke-linejoin="round"></g><g id=""> <path d="M6 12H18M6 12L11 7M6 12L11 17" stroke="#00B6F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    К списку новостей
                </NuxtLink>
            </div>
            <h1 class="text-3xl mb-8 mt-6 text-brand-grey">{{ newsStore.item.title }}</h1>

            <div class="flex flex-col md:flex-row gap-10">
                <div>
                    <img :alt="newsStore.item.title" :src="newsStore.item.cover[0]"
                        class="inline-block rounded-lg mt-4 xl:max-w-[400px] xl:w-[400px] lg:max-w-[300px] lg:w-[300px] max-w-full w-full object-cover">
                    
                </div>
                <div>
                    <p class="text-base font-medium my-2">{{ newsStore.item.description }}</p>
                    <div class="text-lg" v-html="newsStore.item.body"></div>

                </div>
            </div>
        </div>
    </section>

</template>